import type { ModuleMigrationDef } from "@kubdee/sdk";

// #401 — Replace free-text vendor fields on fleet records with a hybrid
// Partner picker (typeable text + dropdown of accounting_partners). To keep
// backward compatibility with existing free-text rows, we KEEP the legacy
// text columns (garage_name / provider_name / vendor_name) and only ADD a
// nullable soft-FK to accounting_partners.id. New records can link to a
// Partner; old rows keep working as text-only.
export const migration: ModuleMigrationDef = {
  key: "005_add_vendor_partner_ids",
  version: "1.4.0",
  sql: `
ALTER TABLE \`fleet_maintenance_records\` ADD COLUMN \`garage_partner_id\` text;
ALTER TABLE \`fleet_insurance_records\` ADD COLUMN \`provider_partner_id\` text;
ALTER TABLE \`fleet_registration_records\` ADD COLUMN \`vendor_partner_id\` text;
ALTER TABLE \`fleet_tax_records\` ADD COLUMN \`vendor_partner_id\` text;
`,
};
